import React from 'react';
import { Theme as RadixTheme, ThemePanel } from '@radix-ui/themes';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <RadixTheme accentColor="indigo" grayColor="slate" panelBackground="solid">
      {children}
      <ThemePanel defaultOpen={false} />
    </RadixTheme>
  );
}
